import { parseISO } from 'date-fns';

export const getNonZTime = (zTime) => {
  return zTime && zTime.slice(-1) === 'Z'
    ? parseISO(zTime.slice(0, -1))
    : parseISO(zTime);
};
